import * as React from "react"
import type { SVGProps } from "react"
const SvgTextItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.25 19.29a1.2 1.2 0 0 1-.89-.37 1.2 1.2 0 0 1-.36-.88q0-.52.36-.9.36-.35.89-.35H10l3-9h-2.75a1.2 1.2 0 0 1-.89-.37A1.2 1.2 0 0 1 9 6.54q0-.53.36-.9.36-.35.89-.35h7.5q.53 0 .89.36t.36.89c0 .53-.12.64-.36.88a1.2 1.2 0 0 1-.89.37H15.5l-3 9h2.25q.53 0 .89.36t.36.89c0 .53-.12.64-.36.88a1.2 1.2 0 0 1-.89.37z" />
  </svg>
)
export default SvgTextItalic
